import { defineAsyncComponent } from "vue";

export default app => {
	app.component("Comment", defineAsyncComponent(() => import("./Comment.vue")));
	app.component("Feed", defineAsyncComponent(() => import("./Feed.vue")));
	app.component("Navbar", defineAsyncComponent(() => import("./Navbar.vue")));
	app.component("Post", defineAsyncComponent(() => import("./Post.vue")));
	app.component("VoteButtons", defineAsyncComponent(() => import("./VoteButtons.vue")));
};
